var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBlueCircleCallUsIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 27 27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_30",
    "data-name": "Ellipse 30",
    cx: 13.5,
    cy: 13.5,
    r: 13.5,
    fill: "#323755"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "start-call",
    d: "M6.821,10.388H1.334a.447.447,0,0,1-.352-.167.46.46,0,0,1-.093-.386A4.863,4.863,0,0,1,5.52,5.984l.112,0a3,3,0,1,0-1.79-.6A5.724,5.724,0,0,0,.027,9.655a1.337,1.337,0,0,0,1.307,1.613H6.821a.44.44,0,1,0,0-.88ZM3.52,2.993A2.113,2.113,0,1,1,5.683,5.105a.437.437,0,0,0-.05,0h-.1a2.115,2.115,0,0,1-2.01-2.11Zm7.61,7.9,0,.006a1.359,1.359,0,0,1-1,.368l0,0A3.422,3.422,0,0,1,7.87,10.173,3.422,3.422,0,0,1,6.777,7.915a1.359,1.359,0,0,1,.368-1l.006,0a.534.534,0,0,1,.741.027c.4.414.64.829.238,1.241l-.353.356a3.673,3.673,0,0,0,.726.981l.025.025a3.673,3.673,0,0,0,.981.726l.356-.353c.412-.4.826-.162,1.241.238a.534.534,0,0,1,.027.741Zm0,0",
    transform: "translate(8.001 7)",
    fill: "#f2f4f6"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueCircleCallUsIcon);
export default __webpack_public_path__ + "static/media/BlueCircleCallUsIcon.81c291e5.svg";
export { ForwardRef as ReactComponent };